import { utils } from 'ethers'

import ERC20 from './abi/ERC20.json'

const Interface = utils.Interface

const ERC20Interface = new Interface(ERC20.abi)

export { ERC20, ERC20Interface }
